<div class="col-12" style="border:1px solid gray;border-radius:5px;margin-top:5px;">
  <h6>
    Requirement for Excel file upload:
    <!--{{importLblTxt.excelFileUploadLbl?importLblTxt.excelFileUploadLbl:import.excelFileUploadLbl}}-->
  </h6>
  <p class="card-text"></p>
  <ul>
    <li>
      Download a sample Excel file with all items
      <button type="button" (click)="generateExcel()" class="link-btn">
        Click here
        <kendo-loader *ngIf="downloadingAllItems" style="color:blue"></kendo-loader>
      </button>
      <!--{{importLblTxt.importContentLbl9?importLblTxt.importContentLbl9:import.importContentLbl9}}-->
    </li>
    <li>
      Please use only <strong>.xlsx</strong> file.
    </li>
    <li>
      More help text
      <!--{{importLblTxt.importContentLbl8?importLblTxt.importContentLbl8:import.importContentLbl8}}-->
    </li>
  </ul>
</div>
<br />
<div class="col-12">
  <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
    <h6 style="padding-top: 5px;">Refresh All</h6>&nbsp;
    <input name="importType" value="reload" type="radio" class="rd"
           (change)="importTypeChanged($event)"
           [(ngModel)]="importType" kendoRadioButton /> &nbsp;&nbsp;
    <h6 style="padding-top: 5px;">Add/Update Existing Items</h6>&nbsp;
    <input name="importType" value="modify" type="radio" class="rd"
           (change)="importTypeChanged($event)"
           [(ngModel)]="importType" kendoRadioButton />
  </div>
</div>


<section>
  <form name="uploadform" class="uploadform" style="margin: 5px 0;">
    <div style="width: 100%;">
      <!--<span class="input-group-text">--><!--Enter the Excel Details below and then click--> <!--{{import.importContentLbl11}} &nbsp;<b>--><!--Upload--><!--{{import.uploadLbl}}--><!--</b>&nbsp;</span>-->

      <div class="input-group" style="margin: 5px 0;">
        <div class="custom-file">
          <input type="file" class="k-button btn" style="width: 100%;"
                 name="fileupload" #fileupload ngModel
                 (change)="readExcel($event)" accept=".xlsx"
                 (click)="$event.target.value=null"
                 required>
        </div>

        <!--<div class="input-group-append">
          <button kendobutton class="k-button btnGreenBorderCls" [disabled]="true">{{import.uploadLbl}}-->
        <!--Upload-->
        <!--</button>
        </div>-->
      </div>
      <!--<p *ngIf="inputData.isSuccess" class="text-success align-center">{{inputData.successMessage}}</p>
      <p *ngIf="inputData.isError" class="text-danger align-center">{{inputData.errorMessage}}</p>-->
    </div>
  </form>
</section>

<section>
  <kendo-grid [data]="itemGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="itemGridstate.sort"
              (sortChange)="itemGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="itemGridstate.take"
              [skip]="itemGridstate.skip"
              [columnMenu]="false"
              (pageChange)="itemGridPageChange($event)"
              (dataStateChange)="itemGridGridDataStateChange($event)"
              [filter]="itemGridstate.filter"
              [loading]="itemReviewGridLoading"
              id="sample-product-admin-grid">

    <kendo-grid-column field="longItemNumber" title="{{labelTexts.longItemNumber}}" [headerClass]="'wrapheader-sample-admin-grid'"
                       [width]="160" [columnMenu]="false" [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="sample-grid-category-div">
          <span>{{dataItem.longItemNumber}}</span>
        </div>
      </ng-template>

      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="description" title="{{labelTexts.description}}"
                       [headerClass]="'wrapheader-sample-admin-grid'" [width]="180" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="availableLocName" title="{{labelTexts.location}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="80" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="qty" title="{{labelTexts.avlQty}}" [width]="90" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.currentInventory}}</span>
        <ng-template #noListItemStock>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="basePrice" title="{{labelTexts.basePrice}}" [width]="80" [columnMenu]="false"
                       [filterable]="false" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.basePrice|currency}}</span>
        <ng-template #noListItemCost>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="cost" title="{{labelTexts.cost}}" [width]="80" [columnMenu]="false"
                       [filterable]="false" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.cost|currency}}</span>
        <ng-template #noListItemCost>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="discount" title="{{labelTexts.discount}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="90" [columnMenu]="false"
                       [filterable]="false" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.discount|number}}%</span>
        <ng-template #noListItemInventory>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column field="salePrice" title="{{labelTexts.salePrice}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="90" [columnMenu]="false"
                       [filterable]="false" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <a role="button" (click)="processPriceHistoryGridData(dataItem)"><span>{{dataItem.salePrice|currency}}</span></a>
        <ng-template #noListItemReorder>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="actionText" title="{{labelTexts.action}}" [headerClass]="'wrapheader-sample-admin-grid'" [width]="90" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span>{{dataItem.actionText}}</span>
        <ng-template #noListItemReorder>
        </ng-template>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>


    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
  </kendo-grid>
</section>

<!--<div class="hr-sect">Uplod Summary</div>
<p>{{uploadSummaryText}}</p>-->

<div class="col-12">
  <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
    <button class="m-3 btn k-button" (click)="goBack()" kendoButton>
      Back
    </button>
    <!--<button class="m-3 btn k-button" (click)="goBack()" kendoButton>
      Export All Items
    </button>-->
    <!--<button class="m-3 btn k-button" (click)="goBack()" kendoButton>
      Validate
    </button>-->
    <button class="m-3 btn k-button" (click)="uploadItems()" *ngIf="readyForUpload" kendoButton>
      Upload
      <kendo-loader *ngIf="uploadInProgress" style="color:blue"></kendo-loader>
    </button>
    <!--<button class="m-3 btn k-button" (click)="testLoad()" kendoButton>
      TestLoad
    </button>-->
  </div>
</div>

<section class="dialogSection">
  <kendo-dialog title="Price History" *ngIf="isPriceHistory" (close)="closePriceHistory()">
    <br />
    <kendo-grid [data]="priceHistoryGridView"
                [height]="470"
                [pageSize]="priceHistoryState.take"
                [skip]="priceHistoryState.skip"
                [sortable]="true"
                [pageable]="true"
                [loading]="finishSampleLoading"
                id="item-price-history-grid">
      <kendo-grid-column field="createdDate" title="Date"
                         [width]="160" [columnMenu]="false" [filterable]="false" [editable]="false">
      </kendo-grid-column>
      <kendo-grid-column field="salePrice" title="Price"
                         [width]="160" [columnMenu]="false" [filterable]="false" [editable]="false">
      </kendo-grid-column>
    </kendo-grid>
  </kendo-dialog>
</section>

